import { render } from "./FormDropdown.vue?vue&type=template&id=752d18d9"
import script from "./FormDropdown.vue?vue&type=script&lang=js"
export * from "./FormDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script